import { InjectionToken } from '@angular/core';

import {
  FormSubmissionDispatch,
  FormSubmissionFacadeEssentials,
  getFacadeFromBaseSelectors,
} from '../../../store/shared/dcr-form-submission/form-submission.facade';
import { StoreService } from '../../../store/shared/store.service';
import { ContactUsRequested } from './contact-us.actions';
import { contactUsSelectors } from './contact-us.selectors';
import { ContactUsPayload } from './types/contact-us.state.type';

export const CONTACT_US_FACADE = new InjectionToken<ContactUsFacade>(
  'CONTACT_US_FACADE',
);

export type ContactUsFacade = FormSubmissionFacadeEssentials<ContactUsPayload> &
  FormSubmissionDispatch<ContactUsPayload>;

export const getContactUsFacade = (storeService: StoreService) => ({
  ...getFacadeFromBaseSelectors<ContactUsPayload>(
    contactUsSelectors,
    storeService,
  ),
  submit: (payload: ContactUsPayload) => {
    storeService.dispatchAction(new ContactUsRequested(payload));
  },
});
